export const CRM_USER_ROLES = [
  {
    value: 'kyc_officer',
    label: 'KYC Officer',
  },
  {
    value: 'admin_crm',
    label: 'Admin CRM',
  },
]
